import { Link } from "react-router-dom";
import { Instagram, Mail, MapPin, Phone, Clock } from "lucide-react";
import { Logo } from "@/components/Navbar";
import { MARCA, CONTATO, RODAPE, CIDADES_ATENDIDAS } from "@/content/site";

const Footer = () => (
  <footer data-testid="main-footer" className="border-t border-white/10 bg-obsidian">
    <div className="mx-auto max-w-7xl px-6 py-16 lg:px-10">
      <div className="grid gap-12 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <Logo />
          <p className="mt-5 max-w-sm text-sm font-light leading-relaxed text-stone-400">{RODAPE.descricao}</p>
          <div className="mt-6 flex gap-4">
            <a
              href={CONTATO.instagramUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-social-instagram"
              aria-label="Instagram"
              className="flex h-10 items-center gap-2 border border-white/10 px-3 text-stone-400 transition-colors duration-300 hover:border-brand hover:text-brand"
            >
              <Instagram size={16} />
              <span className="font-mono text-[11px] tracking-[0.15em]">{CONTATO.instagram}</span>
            </a>
          </div>
        </div>

        <div className="lg:col-span-2">
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-brand">Navegação</p>
          <div className="mt-5 flex flex-col gap-3 text-sm font-light text-stone-400">
            <Link to="/" data-testid="footer-link-inicio" className="transition-colors duration-300 hover:text-brand">Início</Link>
            <Link to="/imoveis" data-testid="footer-link-imoveis" className="transition-colors duration-300 hover:text-brand">Imóveis</Link>
            <Link to="/sobre" data-testid="footer-link-sobre" className="transition-colors duration-300 hover:text-brand">Sobre Nós</Link>
            <Link to="/contato" data-testid="footer-link-contato" className="transition-colors duration-300 hover:text-brand">Contato</Link>
          </div>
        </div>

        <div className="lg:col-span-3">
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-brand">Onde atuamos</p>
          <div className="mt-5 flex flex-wrap gap-x-4 gap-y-2 text-sm font-light text-stone-400">
            {CIDADES_ATENDIDAS.map((c) => (
              <span key={c}>{c}</span>
            ))}
          </div>
        </div>

        <div className="lg:col-span-3">
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-brand">Contato</p>
          <div className="mt-5 space-y-3 text-sm font-light text-stone-400">
            <p className="flex items-start gap-3">
              <MapPin size={15} className="mt-0.5 shrink-0 text-brand" />
              <span>
                {CONTATO.endereco}
                <br />
                {CONTATO.bairro}, {CONTATO.cidade}/{CONTATO.estado} · CEP {CONTATO.cep}
              </span>
            </p>
            <a
              href={`https://wa.me/${CONTATO.whatsapp}`}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-phone"
              className="flex items-center gap-3 transition-colors duration-300 hover:text-brand"
            >
              <Phone size={15} className="shrink-0 text-brand" /> {CONTATO.telefone}
            </a>
            {CONTATO.email && (
              <p className="flex items-center gap-3">
                <Mail size={15} className="shrink-0 text-brand" /> {CONTATO.email}
              </p>
            )}
            <p className="flex items-start gap-3">
              <Clock size={15} className="mt-0.5 shrink-0 text-brand" /> {CONTATO.horario}
            </p>
          </div>
        </div>
      </div>

      <div className="mt-14 flex flex-col gap-3 border-t border-white/10 pt-8 font-mono text-[10px] uppercase tracking-[0.2em] text-stone-600 sm:flex-row sm:items-center sm:justify-between">
        <span>© {new Date().getFullYear()} {MARCA.nomeCompleto} — {MARCA.creci}</span>
        <span>{MARCA.slogan}</span>
      </div>
    </div>
  </footer>
);

export default Footer;
